require('./Stream.scss');

const b = require('app/www/libs/b')('stream');
const bPage = require('app/www/libs/b')('page');

const _ = {
    get: require('lodash/get'),
    pickBy: require('lodash/pickBy'),
};

const React = require('react');
const PropTypes = require('prop-types');
const {stringify} = require('querystring');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const {buildMeta} = require('app/common/libs/seoBuilder');
const Metrika = require('app/www/libs/client/metrika');
const {buildYStatFromBlock} = require('app/common/libs/streamChannel');

const Global = require('app/www/components/blocks/Global/Global');
const Spin = require('app/www/components/blocks/Spin/Spin');
const Ua = require('app/www/components/blocks/Ua/Ua');

const HOST = 'https://yandex.ru';
const URL = `${HOST}/portal/tvstream`;
const SECONDS_30 = 30 * 1000;
const MINUTES_3 = 3 * 60 * 1000;

class Stream extends React.PureComponent {

    constructor(props) {
        super(props);

        if (Global.isClient) {
            this._page = document.querySelector('.page');
            this._pageClass = bPage.mod({stream: true});
        }

        this._close = this._close.bind(this);
        this._hide = this._hide.bind(this);
        this._redirect = this._redirect.bind(this);
        this._changeHistory = this._changeHistory.bind(this);
        this._updateMeta = this._updateMeta.bind(this);
        this._revertMeta = this._revertMeta.bind(this);
        this._onMessage = this._onMessage.bind(this);
        this._onPopState = this._onPopState.bind(this);
    }

    componentDidMount() {
        if (!this.props.onClose) {
            this._page.classList.add(this._pageClass);
            this._changeHistory(true);
        }

        Metrika.reachGoal('TV_ONLINE_PLAYER_START');
        this._timeoutSeconds30 = setTimeout(() => Metrika.reachGoal('TV_ONLINE_PLAYER_30SECONDS'), SECONDS_30);
        this._timeoutMinutes3 = setTimeout(() => Metrika.reachGoal('TV_ONLINE_PLAYER_3MINUTES'), MINUTES_3);

        window.addEventListener('message', this._onMessage);
        window.addEventListener('popstate', this._onPopState);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onMessage);
        window.removeEventListener('popstate', this._onPopState);
    }

    render() {
        if (this.props.onClose) {
            this._page.classList.add(this._pageClass);
            this._changeHistory(true);
            this._updateMeta();
        }

        const spinProps = {
            mods: {
                size: 'l',
            },
        };

        const iframeAttrs = {
            src: this._src,
            allowFullScreen: true,
            allow: 'autoplay; encrypted-media',
        };

        return (
            <div className={b()}>
                <Spin className={b('spin')} {...spinProps} />
                {Global.isClient && (
                    <iframe className={b('iframe')} {...iframeAttrs} />
                )}
            </div>
        );
    }

    /**
     * Формируем source для iframe
     * @returns {string}
     * @private
     */
    get _src() {
        const {
            channel,
            streamId,
            expflags,
            fromBlock,
            streamActive,
        } = this.props;

        const params = _.pickBy({
            stream_channel: channel && (channel.yacFamilyId || channel.id),
            stream_id: streamId || (channel && channel.contentId),
            sk: Global.crc,
            from: Global.id,
            stream_active: streamActive,
        }, Boolean);

        if (fromBlock) {
            params.from_block = buildYStatFromBlock(fromBlock, Ua.isTouchPhone);
        }

        if (expflags) {
            params.slots = encodeURIComponent(expflags);
        }

        return `${URL}?${stringify(params)}`;
    }

    /**
     * Закрываем плеер скрытием или редиректом
     * @private
     */
    _close() {
        if (this.props.onClose) {
            this._hide();
        } else {
            this._redirect();
        }
    }

    /**
     * Скрываем плеер
     * @private
     */
    _hide() {
        this._page.classList.remove(this._pageClass);
        this._changeHistory();
        this._revertMeta();

        clearTimeout(this._timeoutSeconds30);
        clearTimeout(this._timeoutMinutes3);

        this.props.onClose();
    }

    /**
     * Редиректим на предыдущую страницу, главную или страницу канала
     * @private
     */
    _redirect() {
        const {req, referer, isTvReferer, channel} = this.props;
        const urlBuilder = req.lib('urlBuilder');
        let href;

        if (referer) {
            href = isTvReferer
                ? decodeURIComponent(referer)
                : urlBuilder.getIndexUrl();
        } else {
            href = urlBuilder.getChannelUrl(channel.familyId);
        }

        location.href = href;
    }

    /**
     * Добавляем /stream в history
     * Или возвращаемся назад
     * @param {Boolean} [isOpen]
     * @private
     */
    _changeHistory(isOpen) {
        const {
            channel,
            onClose,
            changeHistory,
            transliteratedFamilyTitle,
        } = this.props;

        if (!_.get(window, 'Modernizr.history') || !changeHistory) {
            return;
        }

        this._isOpen = isOpen;
        const urlBuilder = this.props.req.lib('urlBuilder');
        const pathId = transliteratedFamilyTitle || channel.transliteratedFamilyTitle || channel.familyId;
        const pathname = urlBuilder.getStreamUrl(pathId);

        if (isOpen) {
            const method = onClose ? 'pushState' : 'replaceState';
            window.history[method]('', document.title, pathname);
        } else if (location.pathname === pathname) {
            window.history.back();
        }
    }

    /**
     * Меняем мету
     * Сохраняем первоначальную
     * @private
     */
    _updateMeta() {
        const {i18n, channel, updateMeta} = this.props;

        if (!updateMeta) {
            return;
        }

        const seo = buildMeta('stream', i18n, {channelTitle: channel.title});

        this._seo = {
            title: document.title,
        };
        document.title = seo.title;

        this._dom = {
            description: document.querySelector('[name="description"]'),
            keywords: document.querySelector('[name="keywords"]'),
        };

        if (this._dom.description) {
            this._seo.description = this._dom.description.content;
            this._dom.description.content = seo.description;
        }

        if (this._dom.keywords) {
            this._seo.keywords = this._dom.keywords.content;
            this._dom.keywords.content = seo.keywords;
        }
    }

    /**
     * Возвращаем мету на первоначальную
     * @private
     */
    _revertMeta() {
        if (!this.props.updateMeta) {
            return;
        }

        document.title = this._seo.title;

        if (this._dom.description) {
            this._dom.description.content = this._seo.description;
        }

        if (this._dom.keywords) {
            this._dom.keywords.content = this._seo.keywords;
        }
    }

    /**
     * Зыкрываем при получении сообщения "hide"
     * @param {Object} message
     * @private
     */
    _onMessage(message) {
        if (
            _.get(message, 'origin') === HOST &&
            _.get(message, 'data.type') === 'hide'
        ) {
            this._close();
        }
    }

    /**
     * Закрываем при клике на браузерную кнопку "Назад"
     * @private
     */
    _onPopState() {
        if (this.props.onClose && this._isOpen) {
            this._close();
        }
    }

}

Stream.defaultProps = {
    changeHistory: true,
    updateMeta: true,
};

Stream.propTypes = {
    streamId: PropTypes.string,
    channel: PropTypes.object,
    referer: PropTypes.string,
    isTvReferer: PropTypes.bool,
    fromBlock: PropTypes.string,
    changeHistory: PropTypes.bool,
    updateMeta: PropTypes.bool,
    streamActive: PropTypes.string,
    onClose: PropTypes.func,
    expflags: PropTypes.string,
};

module.exports = withReq(withI18n(Stream));
